export default [
  {
    "code": "Home",
    "name": "首页",
    "url": "/business/home",
    "icon": "",
    "affix": "",
    "component": "",
    roles: ['admin', 'doctor', 'pharmacist', 'user']
  },
  {
    "code": "DictionaryMgmt",
    "name": "字典管理",
    "url": "",
    "icon": "",
    "affix": "",
    "component": "",
    roles: ['admin'],
    "children": [
      {
        "code": "ClinicDictionary",
        "name": "诊疗词典",
        "pCode": "DictionaryMgmt",
        "url": "",
        "icon": "",
        "affix": "",
        "component": "",
        "children": [
          {
            "code": "SymptomDictionary",
            "name": "症状词典",
            "pCode": "ClinicDictionary",
            "url": "/business/page/dictionary/clinic_sym_dic/list/list",
            "icon": "",
            "affix": "",
            "component": "",
            roles: ['admin']
          },
          {
            "code": "FamilyDiseaseDictionary",
            "name": "家族病词典",
            "pCode": "ClinicDictionary",
            "url": "/business/page/dictionary/clinic_family_dic/list/list",
            "icon": "",
            "affix": "",
            "component": "",
            roles: ['admin']
          },
          {
            "code": "MedicalHistoryDictionary",
            "name": "病史词典",
            "pCode": "ClinicDictionary",
            "url": "/business/page/dictionary/clinic_his_dic/list/list",
            "icon": "",
            "affix": "",
            "component": "",
            roles: ['admin']
          },
          {
            "code": "FourDiagnosticDictionary",
            "name": "四诊法词典",
            "pCode": "ClinicDictionary",
            "url": "/business/page/dictionary/clinic_fdm_dic/list/list",
            "icon": "",
            "affix": "",
            "component": "",
            roles: ['admin']
          },
          {
            "code": "ConstitutionDictionary",
            "name": "体质词典",
            "pCode": "ClinicDictionary",
            "url": "/business/page/dictionary/clinic_phy_dic/list/list",
            "icon": "",
            "affix": "",
            "component": "",
            roles: ['admin']
          },
          {
            "code": "DiagnosisDictionary",
            "name": "诊断词典",
            "pCode": "ClinicDictionary",
            "url": "/business/page/dictionary/clinic_diag_dic/list/list",
            "icon": "",
            "affix": "",
            "component": "",
            roles: ['admin']
          },
          {
            "code": "AllergyDictionary",
            "name": "过敏史词典",
            "pCode": "ClinicDictionary",
            "url": "/business/page/dictionary/clinic_allergy_dic/list/list",
            "icon": "",
            "affix": "",
            "component": "",
            roles: ['admin']
          },
          {
            "code": "TCMDiseaseDictionary",
            "name": "中医病词典",
            "pCode": "ClinicDictionary",
            "url": "/business/page/dictionary/clinicchdiagdic/list/list",
            "icon": "",
            "affix": "",
            "component": "",
            roles: ['admin']
          },
          {
            "code": "TCMSyndromeDictionary",
            "name": "中医症词典",
            "pCode": "ClinicDictionary",
            "url": "/business/page/dictionary/clinicchyndromedic/list/list",
            "icon": "",
            "affix": "",
            "component": "",
            roles: ['admin']
          },
          {
            "code": "TherapyDictionary",
            "name": "治法词典",
            "pCode": "ClinicDictionary",
            "url": "/business/page/dictionary/clinicchtherapydic/list/list",
            "icon": "",
            "affix": "",
            "component": "",
            roles: ['admin']
          }
        ]
      },
      {
        "code": "MedicineDictionary",
        "name": "医药词典",
        "pCode": "DictionaryMgmt",
        "url": "",
        "icon": "",
        "affix": "",
        "component": "",
        "children": [
          {
            "code": "DrugDescriptionDictionary",
            "name": "药品描述词典",
            "pCode": "MedicineDictionary",
            "url": "/business/page/dictionary/clinic_med_dic/list/list",
            "icon": "",
            "affix": "",
            "component": "",
            roles: ['admin']
          },
          {
            "code": "SupplyChainDictionary",
            "name": "供应链词典",
            "pCode": "MedicineDictionary",
            "url": "/business/page/dictionary/clinic_chain_dic/list/list",
            "icon": "",
            "affix": "",
            "component": "",
            roles: ['admin']
          },
          {
            "code": "MaterialClassifyDictionary",
            "name": "物料分类词典",
            "pCode": "MedicineDictionary",
            "url": "/business/page/dictionary/clinic_classify_dic/list/list",
            "icon": "",
            "affix": "",
            "component": "",
            roles: ['admin']
          },
          {
            "code": "MaterialDictionary",
            "name": "物料词典",
            "pCode": "MedicineDictionary",
            "url": "/business/page/dictionary/clinic_materiel/list/list",
            "icon": "",
            "affix": "",
            "component": "",
            roles: ['admin']
          }
        ]
      }
    ]
  },
  {
    "code": "robot",
    "name": "设备管理",
    "pCode": "",
    "url": "",
    "icon": "",
    "affix": "",
    "component": "",
    roles: ['admin'],
    "children": [
      {
        "code": "robot001",
        "name": "设备管理",
        "pCode": "robot",
        "url": "/business/clinic/robot/list/list",
        "icon": "",
        "affix": "",
        "component": ""
      }
    ]
  },
  {
    "code": "ClinicMgmt",
    "name": "诊所管理",
    "url": "",
    "icon": "",
    "affix": "",
    "component": "",
    roles: ['admin'],
    "children": [
      {
        "code": "Store",
        "name": "门店",
        "pCode": "ClinicMgmt",
        "url": "/business/clinic/store_info",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin']
      },
      {
        "code": "StoreStaff",
        "name": "门店人员",
        "pCode": "ClinicMgmt",
        "url": "/business/clinic/store_user/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin']
      },
      {
        "code": "RegistrationFee",
        "name": "挂号费",
        "pCode": "ClinicMgmt",
        "url": "/business/clinic/enroll_fee/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin']
      },
      {
        "code": "ServiceFee",
        "name": "服务费",
        "pCode": "ClinicMgmt",
        "url": "/business/clinic/serve_fee/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin']
      },
      {
        "code": "PharmacyWarehouse",
        "name": "药库",
        "pCode": "ClinicMgmt",
        "url": "/business/clinic/position/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin']
      }
    ]
  },
  {
    "code": "PharmacyMgmt",
    "name": "药房管理",
    "url": "",
    "icon": "",
    "affix": "",
    "component": "",
    roles: ['admin', 'doctor', 'pharmacist'],
    "children": [
      {
        "code": "DrugInventory",
        "name": "药品库存",
        "pCode": "PharmacyMgmt",
        "url": "/business/manager/clinic/inventory/inventory/inventory/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin', 'doctor', 'pharmacist']
      },
      {
        "code": "InventoryFlow",
        "name": "库存流水",
        "pCode": "PharmacyMgmt",
        "url": "/business/manager/clinic/inventory/inventory/statement/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin', 'pharmacist']
      },
      {
        "code": "InboundMgmt",
        "name": "入库管理",
        "pCode": "PharmacyMgmt",
        "url": "/business/manager/clinic/inventory/change/in_ord/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin', 'pharmacist']
      },
      {
        "code": "OutboundMgmt",
        "name": "出库管理",
        "pCode": "PharmacyMgmt",
        "url": "/business/manager/clinic/inventory/change/out_ord/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin', 'pharmacist']
      },
      {
        "code": "TransferMgmt",
        "name": "调拨管理",
        "pCode": "PharmacyMgmt",
        "url": "/business/manager/clinic/inventory/allocation/allocation_ord/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin', 'pharmacist']
      },
      {
        "code": "InventoryCheckMgmt",
        "name": "盘点管理",
        "pCode": "PharmacyMgmt",
        "url": "/business/manager/clinic/inventory/check/check_ord/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin', 'pharmacist']
      },
      {
        "code": "RetailMgmt",
        "name": "零售管理",
        "pCode": "PharmacyMgmt",
        "url": "/business/manager/clinic/inventory/retail/retail_ord/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin', 'pharmacist']
      },
      // {
      //   "code": "003010",
      //   "name": "体质商品",
      //   "pCode": "003",
      //   "url": "/business/health/tizhi/list/list",
      //   "icon": "",
      //   "affix": "",
      //   roles: ['admin', 'doctor', 'user', 'pharmacist'],
      //   "component": ""
      // },
      {
        "code": "PatentDrugDispense",
        "name": "中成药发药",
        "pCode": "PharmacyMgmt",
        "url": "/business/settlement/take_medicine",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin', 'pharmacist']
      },
      {
        "code": "HerbalDispense",
        "name": "饮片发药",
        "pCode": "PharmacyMgmt",
        "url": "/business/settlement/take_chmedicine",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin', 'pharmacist']
      }
    ]
  },
  {
    "code": "TreatmentMgmt",
    "name": "诊疗管理",
    "url": "",
    "icon": "",
    "affix": "",
    "component": "",
    roles: ['admin', 'doctor', 'user', 'pharmacist'],
    "children": [
      {
        "code": "Registration",
        "name": "挂号",
        "pCode": "TreatmentMgmt",
        "url": "/business/treatment/enroll",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin', 'doctor', 'user', 'pharmacist']
      },
      {
        "code": "MemberMgmt",
        "name": "患者管理",
        "pCode": "TreatmentMgmt",
        "url": "/business/health/patient/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin', 'doctor', 'user', 'pharmacist']
      },
      {
        "code": "TCMDiscussion",
        "name": "中医论病",
        "pCode": "TreatmentMgmt",
        "url": "/business/treatment/medtreatment?type=1",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['doctor', 'user']
      },
      {
        "code": "TCMxiyi",
        "name": "西医论病",
        "pCode": "TreatmentMgmt",
        "url": "/business/treatment/xitreatment?type=2",
        "icon": "",
        "affix": "",
        roles: ['doctor', 'user'],
        "component": ""
      },
      {
        "code": "TCMzylz",
        "name": "中医论证",
        "pCode": "TreatmentMgmt",
        "url": "/business/treatment/zhengtreatment?type=3",
        "icon": "",
        "affix": "",
        roles: ['doctor', 'user'],
        "component": ""
      },
      {
        "code": "FullDiagnosis",
        "name": "全量辩治",
        "pCode": "TreatmentMgmt",
        "url": "/business/treatment/treatment?type=4",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['doctor', 'user']
      },
      {
        "code": "StandardPrescription",
        "name": "标准处方",
        "pCode": "TreatmentMgmt",
        "url": "/business/manager/clinic/treatment/std_prescription/std_prescription/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin', 'doctor']
      },
      {
        "code": "InspectionRecord",
        "name": "检查记录",
        "pCode": "TreatmentMgmt",
        "url": "/business/manager/clinic/treatment/inspection_Record/inspection_Record/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin', 'doctor']
      }
    ]
  },
  {
    "code": "SettlementMgmt",
    "name": "结算管理",
    "url": "",
    "icon": "",
    "affix": "",
    "component": "",
    roles: ['admin', 'user', 'doctor', 'pharmacist'],
    "children": [
      // {
      //   "code": "settlement",
      //   "name": "结算",
      //   "pCode": "business",
      //   "url": "/business/settlement/settlement",
      //   "icon": "",
      //   "affix": "",
      //   roles: ['admin', 'user', 'pharmacist', 'doctor'],
      //   "component": ""
      // },
      {
        "code": "RetailSettlement",
        "name": "零售结算单",
        "pCode": "SettlementMgmt",
        "url": "/business/settlement/retailStlmt/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin']
      },
      {
        "code": "VisitSettlement",
        "name": "就诊结算单",
        "pCode": "SettlementMgmt",
        "url": "/business/settlement/diagStlmt/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin']
      },
      {
        "code": "TherapySettlement",
        "name": "理疗结算单",
        "pCode": "SettlementMgmt",
        "url": "/business/settlement/TherapyStlmt/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin']
      },
      {
        "code": "PhysicalStlmt",
        "name": "体质报告结算单",
        "pCode": "SettlementMgmt",
        "url": "/business/settlement/PhysicalStlmt/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin']
      },
      {
        "code": "MonthlyStlmt",
        "name": "包月结算单",
        "pCode": "SettlementMgmt",
        "url": "/business/settlement/MonthlyStlmt/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin']
      },
      {
        "code": "PhysicalBilling",
        "name": "体检报告月度对账单",
        "pCode": "business",
        "url": "/business/settlement/PhysicalBilling/list/list",
        "icon": "",
        "affix": "",
        roles: ['admin'],
        "component": ""
      },
      {
        "code": "PhysicalBilling",
        "name": "门店运营数据",
        "pCode": "business",
        "url": "/business/settlement/yunying",
        "icon": "",
        "affix": "",
        roles: ['admin'],
        "component": ""
      },
      {
        "code": "constitutionStore",
        "name": "门店体质检测统计",
        "pCode": "business",
        "url": "/business/settlement/constitutionStore",
        "icon": "",
        "affix": "",
        roles: ['admin'],
        "component": ""
      },
      {
        "code": "padusageStore",
        "name": "门店PAD使用情况统计",
        "pCode": "business",
        "url": "/business/settlement/padusageStore",
        "icon": "",
        "affix": "",
        roles: ['admin'],
        "component": ""
      }
    ]
  },
  // {
  //   "code": "evaluate",
  //   "name": "门店评价",
  //   "pCode": "",
  //   "url": "",
  //   "icon": "",
  //   "affix": "",
  //   "component": "",
  //   "children": [{
  //     "code": "treatmentEvaluate",
  //     "name": "诊疗评价",
  //     "pCode": "evaluate",
  //     "url": "/business/evaluate/TreatmentEvaluate/list/list",
  //     "icon": "",
  //     "affix": "",
  //     "component": ""
  //   }, {
  //     "code": "TherapyEvaluate",
  //     "name": "理疗评价",
  //     "pCode": "evaluate",
  //     "url": "/business/evaluate/TherapyEvaluate/list/list",
  //     "icon": "",
  //     "affix": "",
  //     "component": ""
  //   }, {
  //     "code": "ClinicEvaluate",
  //     "name": "门店评估",
  //     "pCode": "evaluate",
  //     "url": "/business/evaluate/ClinicEvaluate/list/list",
  //     "icon": "",
  //     "affix": "",
  //     "component": ""
  //   }
  //   ]
  // },
  // 健康 - 用户
  // {
  //   "code": "user",
  //   "name": "用户管理",
  //   "pCode": "",
  //   "url": "",
  //   "icon": "",
  //   "affix": "",
  //   "component": "",
  //   "children": [{
  //     "code": "UserStore",
  //     "name": "门店授权",
  //     "pCode": "user",
  //     "url": "/business/user/UserStore/list/list",
  //     "icon": "",
  //     "affix": "",
  //     "component": ""
  //   }, {
  //     "code": "Appointment",
  //     "name": "预约信息",
  //     "pCode": "user",
  //     "url": "/business/user/Appointment/list/list",
  //     "icon": "",
  //     "affix": "",
  //     "component": ""
  //   }, {
  //     "code": "Consultation",
  //     "name": "医患关联",
  //     "pCode": "user",
  //     "url": "/business/user/Consultation/list/list",
  //     "icon": "",
  //     "affix": "",
  //     "component": ""
  //   }
  //   ]
  // },
  // 健康 - 检查
  {
    "code": "InspectionItem",
    "name": "检查项目",
    "url": "",
    "icon": "",
    "affix": "",
    "component": "",
    roles: ['admin', 'user', 'doctor', 'pharmacist'],
    "children": [
      {
        "code": "ConstitutionDiagRecord",
        "name": "体质诊断记录",
        "pCode": "InspectionItem",
        "url": "/business/inspect/PhyDiagRecord/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin', 'user', 'doctor', 'pharmacist']
      },
      {
        "code": "InspectRecord",
        "name": "检查记录",
        "pCode": "InspectionItem",
        "url": "/business/inspect/InspectRecord/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin', 'user', 'doctor', 'pharmacist']
      },
      {
        "code": "HealthMgmt",
        "name": "健康管理",
        "pCode": "InspectionItem",
        "url": "/business/inspect/healthPc/list/list",
        "icon": "",
        "affix": "",
        "component": "",
        roles: ['admin', 'user', 'doctor', 'pharmacist']
      }
    ]
  }

  // {
  //   "code": "health",
  //   "name": "健康管理",
  //   "pCode": "",
  //   "url": "",
  //   "icon": "",
  //   "affix": "",
  //   "component": "",
  //   "children": [{
  //     "code": "HealthInfo",
  //     "name": "健康档案",
  //     "pCode": "health",
  //     "url": "/business/health/HealthInfo/list/list",
  //     "icon": "",
  //     "affix": "",
  //     "component": ""
  //   }, {
  //     "code": "MedBatch",
  //     "name": "用药批次",
  //     "pCode": "health",
  //     "url": "/business/health/MedBatch/list/list",
  //     "icon": "",
  //     "affix": "",
  //     "component": ""
  //   }, {
  //     "code": "MedRecord",
  //     "name": "用药记录",
  //     "pCode": "health",
  //     "url": "/business/health/MedRecord/list/list",
  //     "icon": "",
  //     "affix": "",
  //     "component": ""
  //   }, {
  //     "code": "FoodRecord",
  //     "name": "饮食记录",
  //     "pCode": "health",
  //     "url": "/business/health/FoodRecord/list/list",
  //     "icon": "",
  //     "affix": "",
  //     "component": ""
  //   }, {
  //     "code": "SleepRecord",
  //     "name": "睡眠记录",
  //     "pCode": "health",
  //     "url": "/business/health/SleepRecord/list/list",
  //     "icon": "",
  //     "affix": "",
  //     "component": ""
  //   }, {
  //     "code": "SportRecord",
  //     "name": "运动记录",
  //     "pCode": "health",
  //     "url": "/business/health/SportRecord/list/list",
  //     "icon": "",
  //     "affix": "",
  //     "component": ""
  //   }, {
  //     "code": "MassageRecord",
  //     "name": "按摩记录",
  //     "pCode": "health",
  //     "url": "/business/health/MassageRecord/list/list",
  //     "icon": "",
  //     "affix": "",
  //     "component": ""
  //   }
  //   ]
  // }
]
